"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertStaticDataToOptions = convertStaticDataToOptions;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function convertStaticDataToOptions(staticDataItem) {
  return staticDataItem.map(function (item) {
    if (_typeof(item) === 'object') {
      return {
        label: item.name || item.nameForInternal,
        value: item.id
      };
    }

    return {
      label: item,
      value: item
    };
  });
}